import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { ExitToApp } from '@material-ui/icons';
import { NavLink, Switch, Route, Redirect } from 'react-router-dom';
import Users from '../../pages/Users';
import Projects from '../../pages/Projects';
import DailyLogs from '../../pages/Daliylogs';
import MechanicNeeds from '../../pages/MechanicNeeds';
import Drawings from '../../pages/Drawings';
import DriverPlans from '../../pages/DriverPlans';
import AllDriverLogs from '../../pages/AllDailyLogs';
import AllMechanicNeeds from '../../pages/AllMechanicNeeds';
import AllDriverPlans from '../../pages/AllDriverPlans';
import Media from '../../pages/Media';
import SafetyProjects from '../../pages/SafetyProjects';
import SafetyDailyForms from '../../pages/SafetyDailyForms';
import SafetySkyclimberForms from '../../pages/SafetySkyclimberForms';
import SafetyToolboxTalks from '../../pages/SafetyToolboxTalks';
import SafetyDocuments from '../../pages/SafetyDocuments';
import SafetyReports from '../../pages/SafetyReports';
import SafetyConfig from '../../pages/SafetyConfig';
import { logout } from '../../redux/actions/auth';

import './apployout.scss';
import { useDispatch } from 'react-redux';

const navItems = [
  { label: 'Users', path: '/users' },
  { label: 'Projects', path: '/projects' },
  { label: 'Log', path: '/daily-logs' },
  { label: 'Needs', path: '/mechanic-needs' },
  { label: 'Plans', path: '/driver-plans' },
  {
    label: 'Safety',
    path: '/safety/projects',
    isActive: (_, location) => location.pathname.startsWith('/safety')
  }
];

export default function MenuAppBar() {
  const dispatch = useDispatch();

  return (
    <div className="layout">
      <AppBar position="static">
        <Toolbar className="layout__toolbar">
          <IconButton edge="start" className="layout__menuButton">
            BSIS
          </IconButton>
          <div className="layout__menus">
            {navItems.map(({ label, path, isActive }) => (
              <NavLink
                key={path}
                to={path}
                isActive={isActive}
                activeClassName="layout__menuItem--active"
              >
                <Typography variant="h6">{label}</Typography>
              </NavLink>
            ))}
          </div>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
            onClick={() => dispatch(logout())}
          >
            <ExitToApp />
          </IconButton>
        </Toolbar>
      </AppBar>

      <div className="layout__container">
        <Switch>
          <Route path="/users" exact component={Users} />
          <Route path="/projects" exact component={Projects} />
          <Route path="/daily-logs/:userId" exact component={DailyLogs} />
          <Route path="/mechanic-needs/:userId" exact component={MechanicNeeds} />
          <Route path="/projects/drawings/:projectId" exact component={Drawings} />
          <Route path="/projects/media/:projectId" exact component={Media} />
          <Route path="/driver-plans/:userId" exact component={DriverPlans} />
          <Route path="/daily-logs" exact component={AllDriverLogs} />
          <Route path="/mechanic-needs" exact component={AllMechanicNeeds} />
          <Route path="/driver-plans" exact component={AllDriverPlans} />
          <Route path="/safety/projects" exact component={SafetyProjects} />
          <Route path="/safety/daily-forms" exact component={SafetyDailyForms} />
          <Route path="/safety/skyclimber-forms" exact component={SafetySkyclimberForms} />
          <Route path="/safety/toolbox-talks" exact component={SafetyToolboxTalks} />
          <Route path="/safety/documents" exact component={SafetyDocuments} />
          <Route path="/safety/reports" exact component={SafetyReports} />
          <Route path="/safety/config" exact component={SafetyConfig} />
          <Route path="/" exact render={() => <Redirect to="/users" />} />
          <Redirect to="/404" />
        </Switch>
      </div>
    </div>
  );
}
